import { combineReducers } from 'redux'

import { default as alerts } from 'portal-modules/alerts-panel/redux/modules'
import { default as auth } from 'portal-modules/auth/redux/modules'
import { default as classifieds } from 'portal-modules/classifieds/redux/modules'
import { default as common } from 'portal-modules/common/redux/modules'
import { default as companyLinks } from 'portal-modules/company-links/redux/modules'
import { default as contacts } from 'portal-modules/contacts/redux/modules'
import { default as documents } from 'portal-modules/documents/redux/modules/'
import { default as events } from 'portal-modules/events/redux/modules'
import { default as feed } from 'portal-modules/community-feed/redux/modules'
import { default as guests } from 'portal-modules/guests/redux/modules'
import { default as inspections } from 'portal-modules/inspections/redux/modules'
import { default as insurancePolicies } from 'portal-modules/insurance-tp/redux/modules'
import { default as ledger } from 'portal-modules/ledger/redux/modules'
import { default as maintenance } from 'portal-modules/maintenance/redux/modules'
import { default as messages } from 'portal-modules/messages/redux/modules'
import { default as officeInformation } from 'portal-modules/office-information/redux/modules'
import { default as payments } from 'App/modules/payments/redux/modules'
import { default as properties } from 'portal-modules/properties/redux/modules'
import { default as referrals } from 'portal-modules/referrals/redux/modules'
import { default as renewals } from 'portal-modules/renewals/redux/modules'
import { default as rentables } from 'portal-modules/rentable-items/redux/modules'
import { default as reviews } from 'portal-modules/reviews/redux/modules'
import { default as services } from 'portal-modules/services/redux/modules'
import { default as settings } from 'portal-modules/settings/redux/modules'
import { default as utilities } from 'portal-modules/utilities/redux/modules'
import { default as vehicles } from 'portal-modules/vehicles/redux/modules'
import { default as commercial } from 'portal-modules/salesinformation/redux/modules'
import { default as users } from 'portal-modules/users/redux/modules'
import { default as amenitiesModules } from 'App/modules/amenities/redux/modules'
import chatbot from 'App/modules/chatbot/redux/chatbotReducer'
import tenantImprovementsModules from 'App/modules/tenant-improvements/redux'
import app from './app'

export default combineReducers({
  app,
  chatbot,
  ...alerts,
  ...amenitiesModules,
  ...tenantImprovementsModules,
  ...auth,
  ...classifieds,
  ...common,
  ...companyLinks,
  ...contacts,
  ...documents,
  ...events,
  ...feed,
  ...guests,
  ...inspections,
  ...insurancePolicies,
  ...ledger,
  ...maintenance,
  ...messages,
  ...officeInformation,
  ...payments,
  ...properties,
  ...referrals,
  ...renewals,
  ...rentables,
  ...reviews,
  ...services,
  ...settings,
  ...utilities,
  ...vehicles,
  ...commercial,
  ...users,
})
